<template>
  <div class="cfg-contador" :data-time='time'>
    <template v-if='statusGeral !== ""'>
      <RF-Status :cpntStatus='statusGeral' :cpntTamanho='5'></RF-Status>
    </template>

    <template v-else-if='statusGeral === ""'>
      <RF-Aba class="cfg-contador-aba" :data-time='time' :key="'abas-' + Object.keys(abas).length" v-if="Object.keys(abas).length >= 1"
      :cpntAbas="Object.values(abas)"
      :cpntValue="value"
      :cpntOnChange="cfgContadorOnChangeAba">
      <!-- 
          26/05/2021 - 10:33
          RAPHAEL PEDIU PARA REMOVER A OPÇÃO DE ADICIONAR POR ENQUANTO, 
          POIS FICOU COM MEDO QUE DE ALGUM CONFLITO COM A EXPORTAÇÃO      
      -->
      <!-- :cpntOnNewTab="cfgContadorAdicionar"> -->
        <template slot='conteudo'>
          <App-Contador-Config-Cadastro v-if="[ '', null, undefined ].indexOf(value) === -1"
          :key="'aba' + value"
          :cpntCadastro="abas[value].cadastro"
          @ATUALIZAR='cfgContadorIniciar'
          @SETAR_DADOS_NOVO_CONTADOR="cfgContadorSetarDadosNovoContador"></App-Contador-Config-Cadastro>
        </template>
      </RF-Aba>
    </template>
  </div>
</template>

<style>
 .cfg-contador-aba > div {
   width: 620px;
 }
</style>

<script>
  export default {
    components: {
      'RF-Aba': () => import('@/components/rf-geral/aba/RF-Aba-2.vue'),
      'App-Contador-Config-Cadastro': () => import('@/components/contador/config/Contador-Config-Cadastro.vue')
    },
    data: function () {
      return {
        time: '',
        statusGeral: 'carregando',
        abas: {},
        value: ''
      }
    },
    mounted: function () {
      this.cfgContadorIniciar()
    },
    methods: {
      cfgContadorIniciar: function () {
        // SETA O STATUS DA TELA
        this.cfgContadorSetarStatusGeral('carregando')

        // SETA AS ABAS RECEBIDAS
        this.abas = {}

        // LIMPA O VALOR DA VARIAVEL
        this.value = ''

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()

        // CRIA AS ABAS JÁ SALVAS
        this.cfgContadorCriarAbas(() => { this.cfgContadorSetarStatusGeral('') })
      },
      cfgContadorSetarStatusGeral: function (status) {
        // SETA O STATUS DA TELA
        this.statusGeral = status

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      cfgContadorCriarAbas: function (callback = null) {
        this.$store.state.comunicaAPI('/config/contador/get', 'GET', null, (retorno) => {
          if (retorno.data.length === 0) {
            this.cfgContadorAdicionar()
          } else {
            // INICIA A VARIAVEL
            var abas = {}
  
            // MONTA AS ABAS
            for (var indexR in retorno.data) {
              // SETA O STATUS PARA NÃO APRESENTAR NA TELA
              retorno.data[indexR] = this.cfgContadorTratarValoresContador(retorno.data[indexR])

              // SETA O NOME DA CHAVE
              var chave = 'contador_' + retorno.data[indexR].contador.clu
  
              // ADICIONA O VALOR NO VETOR
              abas[chave] = { chave: chave, nome: (retorno.data[indexR].contador.clu +  ' - ' + retorno.data[indexR].contador.cliente), cadastro: retorno.data[indexR] }
            }
  
            // SETA AS ABAS RECEBIDAS
            this.abas = abas

            // SETA A INFORMAÇÃO DA ABA QUE DEVE ABRIR
            if (Object.keys(abas).length >= 1 && [ '', null, undefined ].indexOf(this.value) !== -1) {
              this.cfgContadorOnChangeAba(Object.keys(abas)[0])
            }
  
            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            this.time = new Date().getTime()
          }

          // EXECUTA A FUNÇÃO CALLBACK
          if (callback !== null && typeof callback === 'function') {
            callback()
          }
        }, this.cfgContadorSetarStatusGeral)
      },
      cfgContadorTratarValoresContador: function (dados) {
        // SETA O STATUS PARA NÃO APRESENTAR NA TELA
        dados.contador.status = '1'

        // SETA O NOME DA CIDADE
        // dados.contador.id_estado = dados.contador.id_estado
        dados.contador.id_estado_estado = ''

        if ([ '', null, undefined ].indexOf(dados.contador.id_estado) === -1) {
          dados.contador.id_estado_estado = this.$store.state.UFs.filter(item => item.uf === dados.contador.id_estado)[0].estado
        }

        // SETA O NOME DA CIDADE
        dados.contador.id_cidade_cidade = dados.contador.cidade

        // INICIA O VETOR DA LOGOTIPO
        dados.contador.logotipo = process.env.VUE_APP_S3_URI + process.env.VUE_APP_BUCKET_RF + '/img_cli/nao_encontrada.png'

        // VERIFICA SE TEM LOGOTIPO INSERIDA
        if ([ '', null, undefined ].indexOf(dados.contador.cod_img) === -1 && [ '', null, undefined, '0' ].indexOf(dados.contador.v_img) === -1) {
          dados.contador.logotipo = process.env.VUE_APP_S3_URI + process.env.VUE_APP_BUCKET_RF + '/img_cli/' + dados.contador.cod_img + '.png?v=' + dados.contador.v_img
        }
        
        // RETORNA O VALOR TRATADO
        return dados
      },
      cfgContadorOnChangeAba: function (aba) {
        if ([ '', null, undefined ].indexOf(this.abas[aba]) === -1) {
          // SETA A ABA SELECIONADA
          this.value = aba
  
          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()
        }
      },
      cfgContadorAdicionar: function () {
        // INICIA O VETOR PARA RECEBER OS DADOS PARA NOVA ABA
        var vetor = { cadastro: {} }

        // PEGA O NUMERO DA ULTIMA ABA EXISTENTE NO VETOR
        vetor.index = Object.keys(this.abas).length

        // PEGA O NUMERO DA ULTIMA ABA EXISTENTE NO VETOR
        vetor.chave = 'NOVO_' + vetor.index

        // SETA O NOME DA ABA
        vetor.nome = 'Novo Contador'

        // ADICIONA A NOVA ABA NA TELA
        this.abas[vetor.chave] = vetor
        
        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()

        // ALTERA A ABA SOLICITADA
        setTimeout(() => { this.cfgContadorOnChangeAba(vetor.index) }, 200)
      },
      cfgContadorSetarDadosNovoContador: function (dados) {
        // SETA O STATUS PARA NÃO APRESENTAR NA TELA
        dados = this.cfgContadorTratarValoresContador(dados)

        // ADICIONA A NOVA ABA NA TELA
        this.abas[this.value] = Object.assign(this.abas[this.value], { cadastro: dados })

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      }
    }
  }
</script>
